(function () {
	'use strict';

	angular
		.module('app.myWork')
		.controller('myInventoryOpportunities', myInventoryOpportunities);

	myInventoryOpportunities.$inject = ['$rootScope', '$scope', '$timeout', 'notificationService'];

	function myInventoryOpportunities($rootScope, $scope, $timeout, notificationService) {
		$timeout(function () {
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#viewMyInventoryOpportunities').addClass('selected');
		}, 0);
		globalReportName = 'myInventoryOpportunities';
		notificationService.getUnreadInventoryActions(true);
	}
})();
